import axios from 'axios';

// eslint-disable-next-line import/prefer-default-export
export const setAxiosToken = (token) => {
  if (token) {
    axios.defaults.headers.common.Authorization = token;
  }
};
